/*
 * The Frosted Muzzle — analytics pipeline (Phase 4).
 * The single consumer of `fm:analytics` CustomEvents. Sections never call
 * analytics destinations directly — they dispatch
 * document.dispatchEvent(new CustomEvent('fm:analytics', { detail: { event, payload } }))
 * and this file fans the event out to:
 *   1. window.dataLayer (GTM, if present),
 *   2. Shopify's analytics.publish() (Shopify Pixel-aware destinations, if present).
 * It no-ops cleanly if neither exists. Set localStorage.fm_debug_analytics = '1'
 * to log every event to the console.
 */
(function () {
  'use strict';

  function debugOn() {
    try {
      return localStorage.getItem('fm_debug_analytics') === '1';
    } catch (e) {
      return false;
    }
  }

  function handle(event) {
    var detail = event.detail || {};
    var name = detail.event;
    var payload = detail.payload || {};
    if (!name) return;

    if (debugOn()) {
      // eslint-disable-next-line no-console
      console.log('[fm:analytics]', name, payload);
    }

    // 1. GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));

    // 2. Shopify Pixel-aware destinations
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      } else if (typeof window.analytics === 'object' && typeof window.analytics.publish === 'function') {
        window.analytics.publish(name, payload);
      }
    } catch (e) {
      /* never let analytics break the page */
    }
  }

  document.addEventListener('fm:analytics', handle);
})();
